import { c as _c } from "react/compiler-runtime";
import { LocaleEnum } from '@systemeio/ui';
import { BadRequest } from '@systemeio/util';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { MAILING_SETTINGS_API } from '../api/mailing-settings-api';
import { MailingSettingsEditInterface, MailingSettingsErrorResponseContentInterface, MailingSettingsErrorsInterface, MailingSettingsInterface } from '../types/mailing-settings-interface';
export const useUpdateMailingSettings = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.put,
      showFieldsErrorToast: true
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== fetcher) {
    t1 = {
      fetcher: async (data, errors, setErrors) => {
        ;
        try {
          return await fetcher(`${MAILING_SETTINGS_API}`, data, {
            headers: {
              "X-API-Version": 2
            }
          });
        } catch (t2) {
          const e = t2;
          if (e instanceof BadRequest) {
            const mailingSettingErrors = e.errors as unknown as MailingSettingsErrorResponseContentInterface;
            const unsubscriptionLinkTextErrors = {
              ...errors.unsubscriptionLinkText
            };
            if (mailingSettingErrors.fields.unsubscriptionLinkText) {
              Object.entries(mailingSettingErrors.fields.unsubscriptionLinkText).forEach(t3 => {
                const [locale, error] = t3;
                unsubscriptionLinkTextErrors[locale as LocaleEnum] = error.join("");
              });
            }
            setErrors(prev => ({
              ...prev,
              emailMessageFooter: mailingSettingErrors.fields.emailMessageFooter?.join(""),
              senderEmailAddress: mailingSettingErrors.fields.senderEmailAddress?.join(""),
              senderEmailName: mailingSettingErrors.fields.senderEmailName?.join(""),
              sendgridApiKey: mailingSettingErrors.fields.sendgridApiKey?.join(""),
              testEmailAddress: mailingSettingErrors.fields.testEmailAddress?.join(""),
              unsubscriptionLinkText: unsubscriptionLinkTextErrors
            }));
          }
          throw e;
        }
      }
    };
    $[1] = fetcher;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};